export const addHistoryEntry = (history, change) => {
    const entry = {
        date: new Date(),
        changes: change,
    };
    history.push(entry);
};
